import type { Location } from "react-router-dom";
import type { FromLocationState } from "./types";

export const locationStateIncludesFrom = (location: Location): location is Location<FromLocationState> => {
    if (!location || !location?.state) {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const casted = location as Location<Partial<FromLocationState>>;

    if (!casted.state.from) {
        return false;
    }

    return typeof casted.state.from.pathname === "string";
};
